// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/service/v1/account_manager.proto (package msh.service.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Account } from "../../resource/v1/account_pb";
import { User } from "../../resource/v1/user_pb";
import { Language } from "../../common/v1/language_pb";
import { UserInvitation } from "../../resource/v1/user_invitation_pb";
import { ContactTime } from "../../common/v1/common_pb";

/**
 * @generated from message msh.service.v1.CreateConsumerAccountRequest
 */
export const CreateConsumerAccountRequest = proto3.makeMessageType(
  "msh.service.v1.CreateConsumerAccountRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.CreateConsumerAccountResponse
 */
export const CreateConsumerAccountResponse = proto3.makeMessageType(
  "msh.service.v1.CreateConsumerAccountResponse",
  () => [
    { no: 1, name: "account", kind: "message", T: Account },
    { no: 2, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message msh.service.v1.CreateBusinessAccountRequest
 */
export const CreateBusinessAccountRequest = proto3.makeMessageType(
  "msh.service.v1.CreateBusinessAccountRequest",
  () => [
    { no: 1, name: "business_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "manager_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "manager_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "manager_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetUserRequest
 */
export const GetUserRequest = proto3.makeMessageType(
  "msh.service.v1.GetUserRequest",
  () => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetAccountRequest
 */
export const GetAccountRequest = proto3.makeMessageType(
  "msh.service.v1.GetAccountRequest",
  () => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.CreateBusinessAccountResponse
 */
export const CreateBusinessAccountResponse = proto3.makeMessageType(
  "msh.service.v1.CreateBusinessAccountResponse",
  () => [
    { no: 1, name: "account", kind: "message", T: Account },
    { no: 2, name: "manager", kind: "message", T: User },
  ],
);

/**
 * @generated from message msh.service.v1.GetUserResponse
 */
export const GetUserResponse = proto3.makeMessageType(
  "msh.service.v1.GetUserResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message msh.service.v1.GetAccountResponse
 */
export const GetAccountResponse = proto3.makeMessageType(
  "msh.service.v1.GetAccountResponse",
  () => [
    { no: 1, name: "account", kind: "message", T: Account },
  ],
);

/**
 * @generated from message msh.service.v1.AddBusinessAccountUserRequest
 */
export const AddBusinessAccountUserRequest = proto3.makeMessageType(
  "msh.service.v1.AddBusinessAccountUserRequest",
  () => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_manager", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 7, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AddBusinessAccountUserResponse
 */
export const AddBusinessAccountUserResponse = proto3.makeMessageType(
  "msh.service.v1.AddBusinessAccountUserResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message msh.service.v1.AddBusinessStructureUserRequest
 */
export const AddBusinessStructureUserRequest = proto3.makeMessageType(
  "msh.service.v1.AddBusinessStructureUserRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 6, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AddBusinessStructureUserResponse
 */
export const AddBusinessStructureUserResponse = proto3.makeMessageType(
  "msh.service.v1.AddBusinessStructureUserResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message msh.service.v1.AddConsumerAccountUserRequest
 */
export const AddConsumerAccountUserRequest = proto3.makeMessageType(
  "msh.service.v1.AddConsumerAccountUserRequest",
  () => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 6, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.InviteConsumerAccountUserRequest
 */
export const InviteConsumerAccountUserRequest = proto3.makeMessageType(
  "msh.service.v1.InviteConsumerAccountUserRequest",
  () => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 5, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.InviteConsumerAccountUserResponse
 */
export const InviteConsumerAccountUserResponse = proto3.makeMessageType(
  "msh.service.v1.InviteConsumerAccountUserResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message msh.service.v1.InviteBusinessStructureUserRequest
 */
export const InviteBusinessStructureUserRequest = proto3.makeMessageType(
  "msh.service.v1.InviteBusinessStructureUserRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 5, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.InviteBusinessStructureUserResponse
 */
export const InviteBusinessStructureUserResponse = proto3.makeMessageType(
  "msh.service.v1.InviteBusinessStructureUserResponse",
  [],
);

/**
 * @generated from message msh.service.v1.GetUserInvitationsRequest
 */
export const GetUserInvitationsRequest = proto3.makeMessageType(
  "msh.service.v1.GetUserInvitationsRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetUserInvitationsResponse
 */
export const GetUserInvitationsResponse = proto3.makeMessageType(
  "msh.service.v1.GetUserInvitationsResponse",
  () => [
    { no: 1, name: "invitations", kind: "message", T: UserInvitation, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.GetStructureUsersRequest
 */
export const GetStructureUsersRequest = proto3.makeMessageType(
  "msh.service.v1.GetStructureUsersRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetStructureUsersResponse
 */
export const GetStructureUsersResponse = proto3.makeMessageType(
  "msh.service.v1.GetStructureUsersResponse",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.AcceptUserInvitationRequest
 */
export const AcceptUserInvitationRequest = proto3.makeMessageType(
  "msh.service.v1.AcceptUserInvitationRequest",
  () => [
    { no: 1, name: "user_invitation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 5, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "avatar", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message msh.service.v1.AcceptUserInvitationResponse
 */
export const AcceptUserInvitationResponse = proto3.makeMessageType(
  "msh.service.v1.AcceptUserInvitationResponse",
  [],
);

/**
 * @generated from message msh.service.v1.RefuseUserInvitationRequest
 */
export const RefuseUserInvitationRequest = proto3.makeMessageType(
  "msh.service.v1.RefuseUserInvitationRequest",
  () => [
    { no: 1, name: "user_invitation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.RefuseUserInvitationResponse
 */
export const RefuseUserInvitationResponse = proto3.makeMessageType(
  "msh.service.v1.RefuseUserInvitationResponse",
  [],
);

/**
 * @generated from message msh.service.v1.AddConsumerAccountUserResponse
 */
export const AddConsumerAccountUserResponse = proto3.makeMessageType(
  "msh.service.v1.AddConsumerAccountUserResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message msh.service.v1.GetCurrentAccountsRequest
 */
export const GetCurrentAccountsRequest = proto3.makeMessageType(
  "msh.service.v1.GetCurrentAccountsRequest",
  [],
);

/**
 * @generated from message msh.service.v1.GetCurrentAccountsResponse
 */
export const GetCurrentAccountsResponse = proto3.makeMessageType(
  "msh.service.v1.GetCurrentAccountsResponse",
  () => [
    { no: 1, name: "accounts", kind: "message", T: Account, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.SetUserContactTimeRequest
 */
export const SetUserContactTimeRequest = proto3.makeMessageType(
  "msh.service.v1.SetUserContactTimeRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "contact_time", kind: "message", T: ContactTime, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.SetUserContactTimeResponse
 */
export const SetUserContactTimeResponse = proto3.makeMessageType(
  "msh.service.v1.SetUserContactTimeResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * Request from a device generated jwt (signed via cryptochip private key)
 *
 * @generated from message msh.service.v1.AuthenticateDeviceTokenRequest
 */
export const AuthenticateDeviceTokenRequest = proto3.makeMessageType(
  "msh.service.v1.AuthenticateDeviceTokenRequest",
  () => [
    { no: 1, name: "jwt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Firebase custom token to be used to generate working jwt token used in gRPC
 *
 * @generated from message msh.service.v1.AuthenticateDeviceTokenResponse
 */
export const AuthenticateDeviceTokenResponse = proto3.makeMessageType(
  "msh.service.v1.AuthenticateDeviceTokenResponse",
  () => [
    { no: 1, name: "custom_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.RegisterForPushNotificationRequest
 */
export const RegisterForPushNotificationRequest = proto3.makeMessageType(
  "msh.service.v1.RegisterForPushNotificationRequest",
  () => [
    { no: 1, name: "user_messaging_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.RegisterForPushNotificationResponse
 */
export const RegisterForPushNotificationResponse = proto3.makeMessageType(
  "msh.service.v1.RegisterForPushNotificationResponse",
  [],
);

/**
 * @generated from message msh.service.v1.UnregisterForPushNotificationRequest
 */
export const UnregisterForPushNotificationRequest = proto3.makeMessageType(
  "msh.service.v1.UnregisterForPushNotificationRequest",
  () => [
    { no: 1, name: "user_messaging_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.UnregisterForPushNotificationResponse
 */
export const UnregisterForPushNotificationResponse = proto3.makeMessageType(
  "msh.service.v1.UnregisterForPushNotificationResponse",
  [],
);

